import Model from './Model'
import React from 'react';

export default class Interview extends Model {
    static Key = 'Interview';

    // "id": 950,
    // "interviewed_at": null,
    // "is_approved": null,
    // "hr_notes": null,
    // "hr_approved_at": "2020-07-21T20:53:33+00:00",
    // "hr_rejected_at": null,
    // "communication_score": null,
    // "communication_score_notes": null,
    // "leadership_score": null,
    // "leadership_score_notes": null,
    // "presence_score": null,
    // "presence_score_notes": null,
    // "work_quality_score": null,
    // "work_quality_score_notes": null,
    // "work_history_score": null,
    // "work_history_score_notes": null,
    // "teamwork_score": null,
    // "teamwork_score_notes": null,
    // "critical_thinking_score": null,
    // "critical_thinking_score_notes": null,
    // "work_ethic_score": null,
    // "work_ethic_score_notes": null,
    // "capability_notes": null,
    // "capability_approved_at": "2020-07-21T20:53:33+00:00",
    // "capability_rejected_at": null

    // static normalize(props) {
    //     props.talent_disciplines = TB.keyBy(props.talent_disciplines,'id');
    //     props.services = TB.keyBy(props.services,'id');
    //     return props;
    // }

    static interviewProps = [
        'talent_disciplines', 'talent_service_groups', 'skills', 'talent_skill_score',
        'pending_approval_disciplines_count', 'pending_approval_appealed_disciplines_count',
    ]
    /**********************************
     * HR Assessment
     *********************************** */
    hrAssessment() {

        return {
            interviewed_by: this.hrInterviewedBy(),
            approved_at: this.hr_approved_at,
            rejected_at: this.hr_rejected_at,
            notes: this.hr_notes,
            is_active: this.is_active,
            scores: {
                work_history: {
                    score: this.work_history_score,
                    notes: this.work_history_score_notes,
                    name: 'Work History',
                    label: 'Work History',
                    requirements: [
                        'Five+ years experience is the minimum',
                        'Has the applicant worked at a top agency, consultancy, in-house agency, tech firm?  In other words do they have proven experience?',
                        'Can they point to a track record of success',
                        'Do they have the professionalism to succeed in our model?'
                    ],
                    questions: [
                        'Pleae provide a brief summary of your work history highlighting your contributions at clients and/or employers'
                    ]
                },
                communication: {
                    score: this.communication_score,
                    notes: this.communication_score_notes,
                    name: 'Communication',
                    label: 'Communication',
                    requirements: [
                        'Clarity / Logical thought process',
                        'Confidence',
                        'Can get their point across, but lstens & engages',
                    ],
                    questions: [
                        'How would you describe you communication style?',
                        'Are you a more effective verbal or written communicator?',
                        'How would you approach explaining a complex issue to a client or colleague?',
                    ]
                },
                leadership: {
                    score: this.leadership_score,
                    notes: this.leadership_score_notes,
                    name: 'Leadership',
                    label: 'Leadership',
                    requirements: [
                        'In this case leadership is about setting goals / approaches for success; not necessarily about seniority and management',
                        'Can they set a vision (for the team, for their specific area)',
                        'Driven to succeed; speaks with passion and conviction',
                        'Good decision maker',
                        'Knows how to manage through ambiguity',
                    ],
                    questions: [
                        'How would you describe your leadership style?',
                        'Can you share an example when you led a team through a tough situation (could be a client-related or internal challenge)',
                    ]
                },
                teamwork: {
                    score: this.teamwork_score,
                    notes: this.teamwork_score_notes,
                    name: 'Team Effectiveness',
                    label: 'Team Effectiveness',
                    requirements: [
                        'Embraces collaboration (with team and client)',
                        'Flexible, open to others opinion',
                        'Holds themselves accountable to the team',
                    ],
                    questions: [
                        'What do you think makes a good team player?',
                        'Share examples of how you live up to the traits you described?',
                    ]
                },
                work_quality: {
                    score: this.work_quality_score,
                    notes: this.work_quality_score_notes,
                    name: 'Work Quality & Capability',
                    label: 'Work Quality & Capability',
                    requirements: [
                        'Relative degree of strength across roles and projects (will help determine where to dig deeper in the capability interview)',
                    ],
                    questions: [
                        'Based on the roles you selected to play can you please rank order the top 5 with the first being where you are strongest.  If candidate only has 1-2 roles selected ask them to elaborate on where they’ve played those roles in the past.',
                        'Based on the project types you selected to work on, can you please rank order the top 5 with the first being where you are strongest.  If candidate only has 1-2 projects selected ask them to elaborate on where they’ve played delivered work for the relevant projects.',
                    ]
                },
                work_ethic: {
                    score: this.work_ethic_score,
                    notes: this.work_ethic_score_notes,
                    name: 'Gets It Done',
                    label: 'Gets It Done (and gets is done well)',
                    requirements: [
                        'Talent that will work well in our model',
                        'Are they efficient in how they get work done',
                    ],
                    questions: [
                        'Look for: Self starters, don\'t wait around to be told what to do',
                        'Look for: Have high standards for themselves, the work, their teams',
                        'What does it take to  be a self starter?',
                    ]
                },

            }
        }
    }

    hrOverallScore() {
        let scores = TB.values(this.hrAssessment().scores);

        scores = TB.filter(scores, score => TB.isDefined(score.score));

        if (!scores.length) return false;

        let overall = (TB.sumBy(scores, 'score')) / scores.length;

        return overall.toFixed(1);
    }

    hrWasApproved() {
        return this.hr_approved_at
    }
    hrWasRejected() {
        return this.hr_rejected_at
    }
    hasHRStatus() {
        return this.hrWasApproved() || this.hrWasRejected()
    }


    hrStatusDisplay() {
        if (this.hrWasApproved()) return 'Approved'
        if (this.hrWasRejected()) return 'Rejected'

        return this.hrStarted() ?
            (this.hrMissingScores() ? 'Incomplete' : 'Completed, Pending Decision'
        ) : 'Not Started'
    }
    hrMissingScores() {
        let assessment = this.hrAssessment();

        let missingScores = TB.filter(TB.values(assessment.scores), section => !TB.isDefined(section.score));

        return missingScores.length > 0
    }
    hrStarted() {
        if (this.hasHRStatus()) return true;

        let assessment = this.hrAssessment();

        let scores = TB.filter(TB.values(assessment.scores), section => TB.isDefined(section.score));

        return scores.length > 0
    }

    hrInterviewedAt() {
        if (this.hasHRStatus()) {
            let interviewedAt = this.hrWasApproved()
                ? this.hr_approved_at
                : this.hr_rejected_at

            if (TB.moment(interviewedAt).isValid()) {
                return TB.moment(interviewedAt).format('ll')
            }
        }

        return 'N/A';
    }

    hrInterviewedBy() {
        if (this.hasHRStatus() && this.hr_interviewer) {
            return this.hr_interviewer;
        }
        return 'N/A';
    }

    hasCompletedHRAssessment() {
        return this.hr_approved_at || this.hr_rejected_at
    }

    hrAssessmentStatus() {
        return (
            <React.Fragment>
                {this.hasHRStatus() ? (
                    <span>
                        {this.hrWasApproved() && (
                            <span>
                                <i className="far fa-check-circle text-success"/> Approved
                            </span>
                        )}
                        {this.hrWasRejected() && (
                            <span>
                                <i className="far fa-times-circle text-danger"/> Rejected
                            </span>
                        )}
                    </span>
                ) : (
                    <span>
                        <i className="fas fa-exclamation-triangle text-gray-400"/> Incomplete
                    </span>
                )}
            </React.Fragment>
        )
    }
    hrAssessmentDetail(callback = () => true) {
        return (
            <div className="interview-assessment-actions">
                <p>
                    <span>
                        Status:
                    </span>

                    {this.hasHRStatus() ? (
                        <span>
                            {this.hrWasApproved() && (
                                <span>
                                    <i className="far fa-check-circle text-success"/> Approved
                                </span>
                            )}
                            {this.hrWasRejected() && (
                                <span>
                                    <i className="far fa-times-circle text-danger"/> Rejected
                                </span>
                            )}
                        </span>
                    ) : (
                        <span>
                            <i className="far fa-user-edit text-bold"/> Incomplete
                        </span>
                    )}

                </p>
                {this.hasHRStatus() && (
                    <p>
                        <span>
                            Overall Score:
                        </span>
                        <span>
                            {this.hrOverallScore() || 'N/A'}
                        </span>
                    </p>
                )}

                {this.hasHRStatus() && (
                    <p>
                        <span>
                            {this.hrWasApproved() ? 'Approved At:' : 'Rejected At:'}
                        </span>
                        <span>
                            {this.hrInterviewedAt()}
                        </span>
                    </p>
                )}
                {this.hasHRStatus() && (
                    <p>
                        <span>
                            {this.hrWasApproved() ? 'Approved By:' : 'Rejected By:'}
                        </span>
                        <span>
                             {this.hrInterviewedBy()}
                        </span>
                    </p>
                )}

                {this.hasHRStatus() ? (
                    <button onClick={() => callback()} className="btn btn-link btn-link-primary">
                        View HR
                    </button>
                ): (
                    <button onClick={() => callback()} className="btn btn-xs btn-dark">
                        Start HR
                    </button>
                )}

            </div>
        )
    }

    /**********************************
     * Capability Assessment
    *********************************** */
    static marketplaceStatus = (type,item, forSummary = false) => {
        switch (type) {
            case 'talent_disciplines':
                return Interview.disciplineMarketplaceStatus(item, forSummary);

            case 'services':
            case 'talent_service_groups':
                return Interview.serviceMarketplaceStatus(item, forSummary);
        }
    }
    static disciplineMarketplaceStatus = (discipline, forSummary = false) => {
        let status = {};
        if (!discipline?.is_approved && !discipline?.is_rejected) { // pending
            status = {
                className: 'bg-yellow-100 text-yellow-800',
                title: 'Pending',
            }
        } else if (discipline?.is_rejected) {
            status = {
                className: 'bg-red-100 text-red-800',
                title: 'Not Approved',
            }
            if (discipline.latest_appeal) {
                if (!discipline.latest_appeal?.is_approved && !discipline.latest_appeal?.is_rejected) { // pending
                    status = {
                        className: 'bg-yellow-100 text-yellow-800',
                        title: 'Appeal Requested, Pending',
                    }
                } else if (discipline.latest_appeal?.is_rejected) {
                    status = {
                        className: 'bg-red-100 text-red-800',
                        title: forSummary ? 'Not Approved' : 'Appeal Requested, Rejected',
                    }
                    if (discipline.latest_appeal.latest_appeal) {

                    }
                } else if (discipline.latest_appeal?.is_approved) {
                    status = {
                        className: 'bg-green-100 text-green-800',
                        title: forSummary ? 'Approved' : 'Appeal Requested, Approved',
                    }
                }
            }
        } else if (discipline?.is_approved) {
            status = {
                className: 'bg-green-100 text-green-800',
                title: 'Approved',
            }
        }
        return status
    }
    static serviceMarketplaceStatus = (service, forSummary) => {
        if (!TB.isDefined(service.wripple_score)) {
            return {
                className: 'bg-yellow-100 text-yellow-800',
                title: 'Pending',
            }
        }
        return false;
    }
    capabilityAssessment() {
        return {
            interviewed_by: this.capabilityInterviewedBy(),
            approved_at: this.capability_approved_at,
            rejected_at: this.capability_rejected_at,
            scores: {
                talent_disciplines: [...(this.talent_disciplines || [])],
                services: [...(this.talent_service_groups || [])]
            },
            skills: [...(this.skills || [])],
            talent_skill_score: this.talent_skill_score,
        }
    }

    capabilityAverageScore(type) {
        let scores = this.capabilityAssessment().scores[type];
        if (scores) {
            scores = TB.filter(scores, score => TB.isDefined(score.wripple_score));

            if (scores.length) {
                return ((TB.sumBy(scores, 'wripple_score') / scores.length).toFixed(1)) + "/5"
            }
        }
        return 'N/A'
    }
    capabilityPendingRoleApproval() {
        return this.hasCapabilityStatus() && this.pending_approval_disciplines_count > 0
    }
    capabilityPendingRoleAppealApproval() {
        return this.hasCapabilityStatus() && this.pending_approval_appealed_disciplines_count > 0
    }
    capabilityWasApproved() {
        return this.capability_approved_at
    }
    capabilityWasRejected() {
        return this.capability_rejected_at
    }


    hasCapabilityStatus() {
        return this.capabilityWasApproved() || this.capabilityWasRejected()
    }

    capabilityStatusDisplay() {
        if (this.capabilityWasApproved()) return 'Approved'
        if (this.capabilityWasRejected()) return 'Rejected'

        return this.capabilityStarted() ?
            (this.capabilityMissingScores() ? 'Incomplete' : 'Completed, Pending Decision'
            ) : 'Not Started'
    }
    capabilityMissingScores() {
        let assessment = this.capabilityAssessment();

        let missingScores = TB.filter(assessment.scores, (scores, type) => {
            let sectionScores = TB.filter(scores,
                    score => !TB.isDefined(score.wripple_score)
                        || (type === 'talent_disciplines' && Interview.marketplaceStatus(type,score, true)?.title?.includes('Pending'))
            );
            return sectionScores.length > 0
        });
        return missingScores.length > 0 || !TB.isDefined(assessment.talent_skill_score)
    }

    capabilityStarted() {
        if (this.hasCapabilityStatus()) return true;

        let assessment = this.capabilityAssessment();

        let scores = TB.filter(TB.values(assessment.scores), scores => {
            let sectionScores = TB.filter(scores, score => TB.isDefined(score.wripple_score));
            return sectionScores.length > 0
        });

        return scores.length > 0 || TB.isDefined(assessment.talent_skill_score)
    }

    capabilityInterviewedAt() {
        if (this.hasCapabilityStatus()) {
            let interviewedAt = this.capabilityWasApproved()
                ? this.capability_approved_at
                : this.capability_rejected_at

            if (TB.moment(interviewedAt).isValid()) {
                return TB.moment(interviewedAt).format('ll')
            }
        }

        return 'N/A';
    }

    capabilityInterviewedBy() {
        if (this.hasCapabilityStatus() && this.capability_interviewer) {
            return this.capability_interviewer;
        }
        return 'N/A';
    }

    hasCompletedCapabilityAssessment() {
        return this.capabilityWasApproved() || this.capabilityWasRejected()
    }

    capAssessmentStatus() {
        return (
            <React.Fragment>
                <span className="whitespace-no-wrap">
                    {this.capabilityPendingRoleApproval() ? (
                        <span>
                            <i className="fas fa-exclamation-circle text-warning"/>
                            <span className="whitespace-no-wrap">Roles Pending</span>
                        </span>
                    ) : (
                        this.capabilityPendingRoleAppealApproval() ? (
                            <span>
                                <i className="fas fa-exclamation-circle text-warning"/>
                                <span className="whitespace-no-wrap">Appeals Pending</span>
                            </span>
                        ) : (
                            <React.Fragment>
                                {this.capabilityWasApproved() && (
                                    <span>
                                        <i className="far fa-check-circle text-success"/> Approved
                                    </span>
                                )}
                                {this.capabilityWasRejected() && (
                                    <span>
                                        <i className="far fa-times-circle text-danger"/> Rejected
                                    </span>
                                )}
                                {!this.capabilityWasApproved() && !this.capabilityWasRejected() && (
                                    <span>
                                        <i className="fas fa-exclamation-triangle text-gray-400"/> Incomplete
                                    </span>
                                )}
                            </React.Fragment>
                        )
                    )}
                </span>
            </React.Fragment>
        )
    }

    capAssessmentDetail(callback = () => true) {
        return (
            <div className="interview-assessment-actions">
                <p>
                    <span>
                        Status:
                    </span>
                    <span className="whitespace-no-wrap">
                        {this.capabilityPendingRoleApproval() ? (
                            <span>
                                <i className="fas fa-exclamation-circle text-warning"/>
                                <span className="whitespace-no-wrap">Pending Role Approval</span>
                            </span>
                        ) : (
                            this.capabilityPendingRoleAppealApproval() ? (
                                <span>
                                    <i className="fas fa-exclamation-circle text-warning"/>
                                    <span className="whitespace-no-wrap">Pending Appeal Approval</span>
                                </span>
                            ) : (
                                <React.Fragment>
                                    {this.capabilityWasApproved() && (
                                        <span>
                                            <i className="far fa-check-circle text-success"/> Approved
                                        </span>
                                    )}
                                    {this.capabilityWasRejected() && (
                                        <span>
                                            <i className="far fa-times-circle text-danger"/> Rejected
                                        </span>
                                    )}
                                    {!this.capabilityWasApproved() && !this.capabilityWasRejected() && (
                                        <span>
                                        <i className="far fa-user-edit text-bold"/> Incomplete
                                        </span>
                                    )}
                                </React.Fragment>
                            )
                        )}
                    </span>


                </p>
                {this.capabilityWasApproved() && (
                    <p>
                            <span>
                                Approved At:
                            </span>
                        <span>
                                {TB.moment(this.capability_approved_at).format('ll')}
                            </span>
                    </p>
                )}
                {this.capabilityWasApproved() && (
                    <p>
                            <span>
                                Approved By:
                            </span>
                        <span>
                                 {this.capabilityInterviewedBy()}
                            </span>
                    </p>
                )}
                {this.capabilityWasRejected() && (
                    <p>
                        <span>
                            Rejected At:
                        </span>
                        <span>
                            {TB.moment(this.capability_rejected_at).format('ll')}
                        </span>
                    </p>
                )}
                {this.capabilityWasRejected() && (
                    <p>
                        <span>Rejected By:</span> <span>{this.capabilityInterviewedBy()}</span>
                    </p>
                )}

                {(this.capabilityWasApproved() || this.capabilityWasRejected()) ? (
                    <button onClick={() => callback()} className="btn btn-link btn-link-primary">
                        View Capability
                    </button>
                ): (
                    <button onClick={() => callback()} className="btn btn-xs btn-dark">
                        Start Capability
                    </button>
                )}

            </div>
        )
    }


    /**********************************
     * Assessment Helper Methods
     *********************************** */
    assessmentStarted(type) {
        switch (type) {
            case 'hr':
                return this.hrStarted();
            case 'capability':
                return this.capabilityStarted()
        }
    }

    assessmentMissingScores(type) {
        switch (type) {
            case 'hr':
                return this.hrMissingScores();
            case 'capability':
                return this.capabilityMissingScores()
        }
    }

    hasAssessmentStatus(type) {
        switch (type) {
            case 'hr':
                return this.hasHRStatus();
            case 'capability':
                return this.hasCapabilityStatus()
        }
    }

    assessmentWasApproved(type) {
        switch (type) {
            case 'hr':
                return this.hrWasApproved();
            case 'capability':
                return this.capabilityWasApproved()
        }
    }
    assessmentWasRejected(type) {
        switch (type) {
            case 'hr':
                return this.hrWasRejected();
            case 'capability':
                return this.capabilityWasRejected()
        }
    }

    applicationAssessmentStatus() {

        if (this.assessmentWasRejected('hr') || this.assessmentWasRejected('capability')) {
            return "Rejected"
        }

        if (this.assessmentWasApproved('hr') && this.assessmentWasApproved('capability')) {
            return "Approved"
        }
        if (!this.hasAssessmentStatus('hr') && !this.hasAssessmentStatus('capability')) {
            return "Pending Assessment"
        }
        return "Incomplete"
    }
    applicationAssessmentColor() {
        if (!this.hasAssessmentStatus('hr') && !this.hasAssessmentStatus('capability')) {
            return TB.config('color.warning-dark')
        }
        if (this.assessmentWasRejected('hr') || this.assessmentWasRejected('capability')) {
            return TB.config('color.danger')
        }

        if (this.assessmentWasApproved('hr') && this.hasAssessmentStatus('capability')) {
            return TB.config('color.success-darker')
        }
        return '#797979'
    }

}